import { useEffect, useState } from 'react';
import useGetMostViewedOrMostRecentYMM from '@/home/RecommendedCarousels/hooks/useGetMostViewedOrMostRecentYMM';
import useGetVehicles from '~/hooks/home/useGetVehicles';
import { AppliedFilters } from '~/services/common/contracts';

export default function useGetBudgetFriendlyVehicles() {
  const { make, model, price = 0 } = useGetMostViewedOrMostRecentYMM() ?? {};
  const [filters, setFilters] = useState<Partial<AppliedFilters>>({});

  useEffect(() => {
    if (!make || !model) return;

    setFilters({
      makes: [{ name: make, models: [{ name: model }] }],
      price: { max: Math.floor(price * 0.9) }
    });
  }, [make, model, price]);

  const { vehicles, isLoaded } = useGetVehicles(
    filters,
    make != null,
    'Budget Friendly Vehicles'
  );

  return { vehicles, isLoaded };
}
